module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[55]420.adacd00.woff2";